module.exports = {
  canvas: require('./canvas'),
  svg: require('./svg')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g/lib/renderers/index.js
// module id = 253
// module chunks = 0 1 2